module.exports = "<router-outlet></router-outlet>\r\n\r\n<app-modal-sessao #modalSessao></app-modal-sessao>\r\n\r\n<app-loader></app-loader>\r\n\r\n<snc-privacy-notice\r\n  s-url-privacy-notice=\"https://www.senac.br/politica-de-privacidade.html\"\r\n  s-text-privacy-notice=\"Usamos cookies e tecnologias semelhantes para melhorar sua experiência neste site, personalizar publicidade e recomendar conteúdo de seu interesse. Ao utilizar nossos serviços, você concorda com esse monitoramento.\">\r\n</snc-privacy-notice>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main